// Função utilitária para verificar se o valor possui sequência numérica crescente ou decrescente de qualquer tamanho
function isSequenciaNumerica(val: string, length: number): boolean {
  if (val.length < length) return false;
  // Gera sequências crescentes e decrescentes para o tamanho informado
  const baseCrescente = "01234567890".repeat(2);
  const baseDecrescente = "9876543210".repeat(2);
  for (let i = 0; i <= baseCrescente.length - length; i++) {
    const seqCresc = baseCrescente.slice(i, i + length);
    const seqDecresc = baseDecrescente.slice(i, i + length);
    if (val === seqCresc || val === seqDecresc) {
      return true;
    }
  }
  return false;
}

// Função utilitária para verificar se todos os caracteres de um valor são repetidos em um determinado length
function hasRepeatedChars(val: string, length: number): boolean {
  if (val.length < length) return false;
  const char = val[0];
  for (let i = 1; i < length; i++) {
    if (val[i] !== char) return false;
  }
  return true;
}

function replaceNonNumericChars(val: string): string {
  return val.replace(/\D/g, "");
}

export { isSequenciaNumerica, hasRepeatedChars, replaceNonNumericChars };
